import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddPhotoAlternateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_photo_alternate"}/>
}
